
import React from 'react';
import { RecommendationPriority } from '@/types/assessment';
import { AlertCircle, CircleDashed, CheckCircle2 } from 'lucide-react';

interface PriorityBadgeProps {
  priority: RecommendationPriority;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  switch (priority) {
    case 'high':
      return (
        <div className="flex items-center gap-1 text-red-600">
          <AlertCircle className="h-4 w-4" />
          <span>High</span>
        </div>
      );
    case 'medium':
      return (
        <div className="flex items-center gap-1 text-amber-600">
          <CircleDashed className="h-4 w-4" />
          <span>Medium</span>
        </div>
      );
    case 'low':
      return (
        <div className="flex items-center gap-1 text-green-600">
          <CheckCircle2 className="h-4 w-4" />
          <span>Low</span>
        </div>
      );
    default:
      return null;
  }
};
